/*
 * NextGenn engine · the bag's two sentences.
 *
 *   <ngs-bag-note>    "$12 more and delivery is free." with its hairline, and
 *                     the cash line. Shopify writes it right on the first
 *                     load (snippets/ngs-bag-note.liquid); this keeps it right
 *                     while the bag changes without a page load.
 *   <ngs-bag-drawer>  carries the same sentences as <template>s and puts them
 *                     into Dawn's drawer, which is not ours to edit and which
 *                     redraws itself from the server on every change. So they
 *                     are put back after every redraw.
 *
 * It listens where the rest of the theme already talks: Dawn's cart pub/sub
 * (assets/pubsub.js, PUB_SUB_EVENTS.cartUpdate), which Dawn's product form,
 * Dawn's cart lines and our own NGSCart.add all publish to. A change to a line
 * arrives with the whole bag in it; an add arrives with only the new line, so
 * then the bag is asked for once (/cart.js).
 *
 * IT ALSO KEEPS THE FREE BOTTLE HONEST. Where the shop gives a bottle away
 * over a number (NextGenn: delivery in the theme settings, and a real automatic
 * discount behind it), this puts that bottle in the bag when the bag reaches
 * the number and takes it out again when it falls below, through Dawn's own
 * remove path so the page redraws exactly as it would if a customer had pressed
 * it. A gift nobody remembers to add is not a gift, and a gift still sitting in
 * the bag after it stopped being free is a charge nobody agreed to.
 *
 * If the customer takes it out themselves while it is still free, that is an
 * answer: it is not put back for the rest of the session.
 *
 * Loaded by more than one section on the cart page, hence the guard.
 */
(function () {
  if (customElements.get('ngs-bag-note')) return;

  var notes = new Set();
  var last = null; /* { total, paid, count } in cents and items, once known */
  var heard = 0; /* when the bag last told us something */
  var busy = false; /* a gift is being put in or taken out right now */
  var sawGift = false; /* the free bottle has been in the bag this session */
  var DECLINED = 'ngs-gift-declined';

  /* sessionStorage throws in a locked-down browser; a gift is not worth an
     exception, so every touch of it is wrapped. */
  function declined(set) {
    try {
      if (set) window.sessionStorage.setItem(DECLINED, '1');
      return window.sessionStorage.getItem(DECLINED) === '1';
    } catch (error) {
      return false;
    }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Shopify's money formats, and the habit of the page: $12, never $12.00. */
  function money(cents, format) {
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var found = (format || '').match(pattern);
    var kind = found ? found[1] : 'amount';
    var whole = cents % 100 === 0;

    function write(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(whole ? 0 : decimals).split('.');
      var head = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }

    var amount;
    switch (kind) {
      case 'amount_no_decimals':
        amount = write(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = write(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = write(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = write(2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = write(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        amount = write(2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        amount = write(2, ' ', '.');
        break;
      default:
        amount = write(2, ',', '.');
    }
    return found ? format.replace(pattern, amount) : amount;
  }

  /* The gift is weighed on what the bag is worth BEFORE any discount and
     without the gift itself, because that is how Shopify weighs it; delivery is
     weighed on the total actually being paid, because that is how the shipping
     rate does. Two rungs, two numbers, on purpose. */
  function state(cart) {
    var gift = spec();
    var paid = 0;
    (cart.items || []).forEach(function (line) {
      if (gift && line.handle === gift.handle) return;
      paid += line.original_line_price;
    });
    return { total: cart.total_price, paid: paid, count: cart.item_count, items: cart.items || [] };
  }

  function read(event) {
    var data = event && event.cartData;
    /* An add answers with only the line that was added, so the bag itself is
       asked for unless the whole thing really is in hand. */
    if (data && typeof data.total_price === 'number' && typeof data.item_count === 'number' && Array.isArray(data.items) && data.item_count === data.items.length) {
      return Promise.resolve(state(data));
    }
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(state);
  }

  /* The free bottle, as the section wrote it onto whichever note is on the
     page. No note with a gift rung: there is no gift, and nothing happens. */
  function spec() {
    var found = null;
    notes.forEach(function (note) {
      if (!found && note.dataset.giftOver) {
        found = {
          over: Number(note.dataset.giftOver) || 0,
          id: note.dataset.giftId,
          handle: note.dataset.giftHandle,
        };
      }
    });
    return found && found.over > 0 && found.id ? found : null;
  }

  /* Taking the bottle out again, and redrawing whatever bag is on the screen.
     Dawn's own updateQuantity cannot be borrowed for this: it reads
     `event.currentTarget` on its first line and asks for cart-page sections by
     id, so with no event and on a product page it throws. What it does is
     simple enough to do here — ask for the same sections and put them in —
     and it is asked for by the line's KEY, never its position, because a
     position moves the moment anything else in the bag changes. */
  function pull(key) {
    var drawer = document.querySelector('cart-drawer');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var want = ['cart-icon-bubble'];
    if (drawer) want.push('cart-drawer');
    if (items) want.push(items.dataset.id || 'main-cart-items');
    if (footer) want.push(footer.dataset.id || 'main-cart-footer');

    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0, sections: want.join(','), sections_url: window.location.pathname }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var sections = cart.sections || {};
        if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
          drawer.renderContents(cart);
          if (!cart.item_count) drawer.classList.add('is-empty');
        }
        /* The cart page redraws through its own two sections: the lines and
           the totals, or the total would still count a bottle that has gone. */
        [
          [items, '.js-contents'],
          [footer, '.js-contents'],
        ].forEach(function (pair) {
          var host = pair[0];
          if (!host) return;
          var html = sections[host.dataset.id || host.id];
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(pair[1]);
          var here = host.querySelector(pair[1]);
          if (fresh && here) here.innerHTML = fresh.innerHTML;
        });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var freshBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ngs-gift', cartData: cart });
        }
        return tell(state(cart));
      });
  }

  function keepGift(bag) {
    var gift = spec();
    if (!gift || busy || !bag || !Array.isArray(bag.items)) return;

    var mine = '';
    var theirs = false;
    bag.items.forEach(function (line) {
      if (line.handle !== gift.handle) return;
      /* A bottle they chose themselves is theirs. It is never taken out, and
         it means the gift is already on the page. */
      if (line.properties && line.properties._gift) {
        if (!mine) mine = line.key;
      } else {
        theirs = true;
      }
    });
    var here = Boolean(mine) || theirs;
    var earned = bag.paid >= gift.over;

    if (earned && here) {
      sawGift = true;
      return;
    }
    if (earned && !here) {
      /* It was in the bag and now it is not, while it is still free: they took
         it out, and that is an answer. */
      if (sawGift || declined()) {
        declined(true);
        return;
      }
      if (!window.NGSCart) return;
      busy = true;
      window.NGSCart.add([{ id: gift.id, quantity: 1, properties: { _gift: gift.handle } }])
        .then(function () {
          sawGift = true;
        })
        .catch(function () {})
        .then(function () {
          busy = false;
        });
      return;
    }
    if (!earned && mine) {
      /* It has stopped being free. Nobody is charged for a present. */
      busy = true;
      Promise.resolve(pull(mine))
        .catch(function () {})
        .then(function () {
          busy = false;
        });
    }
  }

  function tell(bag) {
    if (!bag || typeof bag.total !== 'number') return;
    last = bag;
    notes.forEach(function (note) {
      note.show(bag);
    });
    keepGift(bag);
  }

  function refresh(event) {
    heard = Date.now();
    return read(event)
      .then(tell)
      .catch(function () {
        /* A sentence that cannot be refreshed is left as Shopify wrote it. */
      });
  }

  customElements.define(
    'ngs-bag-note',
    class NGSBagNote extends HTMLElement {
      connectedCallback() {
        notes.add(this);
        if (last) {
          this.show(last);
          return;
        }
        /* A PAGE THAT LOADS WITH THE WRONG BAG PUTS ITSELF RIGHT. Shopify has
           already told us both answers — whether the free bottle is earned and
           whether it is in the bag — so the bag is only asked about when those
           two disagree: somebody who filled the bag yesterday and came back
           today, or emptied it in another tab. Every other page load costs
           nothing. */
        var earned = this.hasAttribute('data-gift-earned');
        var inside = this.hasAttribute('data-gift-in');
        if (this.dataset.giftOver && earned !== inside) refresh();
      }

      disconnectedCallback() {
        notes.delete(this);
      }

      show(bag) {
        var over = Number(this.dataset.over) || 0;
        var left = Math.max(0, over - bag.total);
        var paying = left > 0 || !over;
        var giftOver = Number(this.dataset.giftOver) || 0;
        var giftLeft = Math.max(0, giftOver - (bag.paid || 0));
        var top = Math.max(over, giftOver);
        var line = this.querySelector('[data-ngs-line]');
        var fill = this.querySelector('[data-ngs-fill]');
        var notch = this.querySelector('[data-ngs-notch]');
        var small = this.querySelector('[data-ngs-small]');

        this.hidden = bag.count === 0;
        var page = this.closest('[data-ngs-bag-page]');
        if (page) page.classList.toggle('is-empty', bag.count === 0);

        if (line) {
          /* The rung that is next, and once delivery is free the bottle. */
          var words;
          if (paying) {
            words = (this.dataset.more || '').replace('[amount]', money(left, this.dataset.money));
          } else if (giftOver && giftLeft > 0) {
            words = (this.dataset.giftMore || '').replace('[amount]', money(giftLeft, this.dataset.money)).replace('[bottle]', this.dataset.giftName || '');
          } else if (giftOver) {
            words = (this.dataset.giftFree || '').replace('[bottle]', this.dataset.giftName || '');
          } else {
            words = this.dataset.free || '';
          }
          if (line.textContent !== words) line.textContent = words;
        }
        if (fill) fill.style.setProperty('inline-size', (top ? Math.min(100, (bag.total / top) * 100) : 100) + '%');
        if (notch) notch.classList.toggle('is-past', left === 0);
        if (small) {
          var quiet = (paying ? this.dataset.small : this.dataset.smallFree) || '';
          if (small.textContent !== quiet) small.textContent = quiet;
          small.hidden = !quiet;
        }
      }
    }
  );

  customElements.define(
    'ngs-bag-drawer',
    class NGSBagDrawer extends HTMLElement {
      connectedCallback() {
        this.drawer = document.querySelector('cart-drawer');
        this.delivery = this.querySelector('template[data-ngs-delivery]');
        this.cod = this.querySelector('template[data-ngs-cod]');
        this.goes = this.querySelector('template[data-ngs-goes-with]');
        this.gift = this.querySelector('template[data-ngs-gift]');
        if (!this.drawer) return;

        /* In the theme editor this section is redrawn with new words: out with the old ones first. */
        this.drawer.querySelectorAll('[data-ngs-mounted]').forEach(function (old) {
          old.remove();
        });
        this.mount();

        this.watch = new MutationObserver(this.mount.bind(this));
        this.watch.observe(this.drawer, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.watch) this.watch.disconnect();
      }

      mount() {
        var footer = this.drawer.querySelector('.drawer__footer');
        if (!footer) return;
        var placed = false;

        if (this.delivery && !footer.querySelector('ngs-bag-note[data-ngs-mounted]')) {
          var note = this.delivery.content.firstElementChild;
          if (note) {
            note = note.cloneNode(true);
            note.setAttribute('data-ngs-mounted', '');
            footer.insertBefore(note, footer.firstChild);
            placed = true;
          }
        }

        var buttons = footer.querySelector('.cart__ctas');
        if (this.cod && buttons && !buttons.querySelector('[data-ngs-mounted]')) {
          var cash = this.cod.content.firstElementChild;
          if (cash) {
            cash = cash.cloneNode(true);
            cash.setAttribute('data-ngs-mounted', '');
            buttons.appendChild(cash);
          }
        }

        /* INSIDE THE LINES, NOT BESIDE THEM. Dawn's drawer is a flex column:
           a header, the lines (which take what is left and scroll), and a
           footer. Hung between the lines and the footer, these two took 218 px
           of that column for themselves — and the lines, being the only part
           that gives, were squeezed to 221 px. A bag with two things in it
           showed the first line whole, the second cut in half, and the gift
           panel sitting on top of where the rest of it should have been.
           Measured: 339 px of lines in a 221 px box.

           Put inside the scrolling part, they cost the lines nothing: the
           lines, the wrap and the pair now scroll together as one column, and
           the footer keeps what it always had. Dawn replaces this element
           whole on every cart change, which is why mount() runs again on every
           mutation and puts them back. */
        var lines = this.drawer.querySelector('cart-drawer-items');

        /* The wrap sits directly under the lines, where somebody is still
           thinking about what is in the bag rather than about paying. */
        if (this.gift && lines && !lines.querySelector('ngs-gift[data-ngs-mounted]')) {
          var wrap = this.gift.content.firstElementChild;
          if (wrap) {
            wrap = wrap.cloneNode(true);
            wrap.setAttribute('data-ngs-mounted', '');
            lines.appendChild(wrap);
          }
        }

        /* "Goes with" follows it, still above the footer and still after
           everything already in the bag. */
        if (this.goes && lines && !lines.querySelector('ngs-goes-with[data-ngs-mounted]')) {
          var deck = this.goes.content.firstElementChild;
          if (deck) {
            deck = deck.cloneNode(true);
            deck.setAttribute('data-ngs-mounted', '');
            lines.appendChild(deck);
          }
        }

        /* Dawn redrew the drawer and nobody said why: ask the bag, so the
           sentence is never the one from the first page load. */
        if (placed && Date.now() - heard > 1500 && this.asked) refresh();
        this.asked = true;
      }
    }
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  /* Back from the checkout, the browser may show this page as it was left. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
